<template>
    <div>
        <section class="cmn-section decoration-detail-hero-section">

                <div class="decoration-detail-hero">
                    <div class="decoration-detail-hero__left decoration-intro-content">
                        <nav class="decoration-breadcrumb decoration-detail-hero__breadcrumb" aria-label="breadcrumb">
                            <router-link class="decoration-breadcrumb__link" to="/">Home</router-link>
                            <span class="decoration-breadcrumb__sep" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
<path d="M4 11.6667L7.33333 8.33333L4 5" stroke="#1D6CB5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.33594 11.6667L11.6693 8.33333L8.33594 5" stroke="#1D6CB5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>
                            <router-link class="decoration-breadcrumb__link" :to="{ name: 'DecorationMethods' }">Decoration Methods &amp; Pricing</router-link>
                            <span class="decoration-breadcrumb__sep" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
<path d="M4 11.6667L7.33333 8.33333L4 5" stroke="#1D6CB5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.33594 11.6667L11.6693 8.33333L8.33594 5" stroke="#1D6CB5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></span>
                            <span class="decoration-breadcrumb__current" aria-current="page">{{ service.service_name || "Not uploaded" }}</span>
                        </nav>
                       <div class="decoration-detail-hero__content"> 
                        <h1 class="decoration-detail-service-name">{{ service.ecomm_display || service.service_name || "Not uploaded" }}</h1>
                        <div class="decoration-detail-hero__desc" v-html="service.service_description || service.description || 'Not uploaded'"></div>
                        <!--
                          To bring back top CTA, uncomment this:
                        <router-link to="/" class="btn decoration-shop-now-btn decoration-detail-hero__cta">Shop Now</router-link>
                        -->
                       </div>
                    </div>
                    <div class="decoration-detail-hero__right">
                        <div v-if="service.service_banner" class="decoration-detail-hero__media">
                            <img :src="service.service_banner" class="detail-service-banner_img" alt="service-banner" />
                        </div>
                        <div v-else class="not-uploaded-box decoration-detail-hero__fallback">Not uploaded</div>
                    </div>
                </div>
        </section>

        <section class="cmn-section print-service-section">
            <div class="container">
                <div class="row why-section-row">
                    <div class="col-md-6">
                        <div v-if="whyDisplayImage || hasWhyVideo" class="why-media-wrap">
                            <img v-if="whyDisplayImage" :src="whyDisplayImage" class="w-100 why-display-image" alt="why-media" />
                            <video
                                v-else
                                :src="whyVideoSource"
                                class="w-100 why-display-image"
                                muted
                                playsinline
                                preload="metadata"
                            ></video>
                            <a
                                v-if="hasWhyVideo"
                                href="javascript:void(0)"
                                class="why-play-overlay"
                                @click.prevent="openVideoPopup"
                            >
                                <svg class="why-play-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5 5.00059C4.9999 4.64868 5.09265 4.30298 5.26888 3.99838C5.44512 3.69379 5.69861 3.44108 6.00375 3.26579C6.30889 3.09049 6.65488 2.99882 7.00679 3.00001C7.3587 3.00121 7.70406 3.09523 8.008 3.27259L20.005 10.2706C20.3078 10.4463 20.5591 10.6983 20.7339 11.0016C20.9088 11.3049 21.0009 11.6487 21.0012 11.9987C21.0015 12.3488 20.91 12.6928 20.7357 12.9963C20.5614 13.2999 20.3105 13.5524 20.008 13.7286L8.008 20.7286C7.70406 20.906 7.3587 21 7.00679 21.0012C6.65488 21.0024 6.30889 20.9107 6.00375 20.7354C5.69861 20.5601 5.44512 20.3074 5.26888 20.0028C5.09265 19.6982 4.9999 19.3525 5 19.0006V5.00059Z" fill="white" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                            </a>
                        </div>
                        <div v-else class="not-uploaded-box">Not uploaded</div>
                    </div>
                    <div class="col-md-6 why-section-text-col">
                        <h3 class="decoration-section-heading">{{ whyServiceHeading }}</h3>
                        <div
                            class="decoration-section-description why-section-description"
                            v-html="service.dtg_description || 'Not uploaded'"
                        ></div>
                    </div>
                </div>
            </div>
        </section>

        <section class="cmn-section slider-section decoration_slider">
            <div class="container">
                <h3 class="decoration-section-heading">Product Review</h3>
                <div v-if="reviewImages.length" class="product-review-slider product-review-slider--owl">
                    <div class="owl-carousel product-review-owl" ref="productReviewCarousel">
                        <div
                            class="item product-review-slide"
                            v-for="img in reviewImages"
                            :key="img.id"
                        >
                            <div
                                class="product-review-slide__box insta_feed position-relative"
                                v-if="img.image_path"
                            >
                                <img
                                    :src="img.image_path"
                                    :alt="img.image_name"
                                    class="product-review-image w-100"
                                />
                                <div
                                    class="insta_feed_content d-flex justify-content-center align-items-center text-center flex-column"
                                >
                                    <div class="likes_coments d-flex">
                                        <div
                                            class="likes d-flex justify-content-center align-items-center"
                                        >
                                            <img
                                                src="/maincss/images/heart_outline_white.svg"
                                                alt=""
                                            />
                                            <p
                                                class="font_size_12 text_white ml_6 mb-0 w-100"
                                            >
                                                1.7k
                                            </p>
                                        </div>
                                        <div
                                            class="likes d-flex justify-content-center align-items-center ml_44"
                                        >
                                            <img
                                                src="/maincss/images/question_white.svg"
                                                alt=""
                                            />
                                            <p
                                                class="font_size_12 text_white ml_6 mb-0 w-100"
                                            >
                                                31
                                            </p>
                                        </div>
                                    </div>
                                    <p class="font_size_13 text_white mt_32">
                                        {{
                                            img.image_name ||
                                                "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt"
                                        }}
                                    </p>
                                </div>
                            </div>
                            <div v-else class="not-uploaded-box decoration-service-banner-fallback">Not uploaded</div>
                            <p class="product-review-name">{{ img.image_name || "Not uploaded" }}</p>
                        </div>
                    </div>
                </div>
                <div v-else class="text-muted">Not uploaded</div>
            </div>
        </section>

        <section v-if="randomServices.length" class="cmn-section decoration-section">
            <div class="container">
                <h3 class="decoration-section-heading">You might also like</h3>
                <div class="row brand_row decoration-cards-row">
                    <div class="col-sm-6 col-md-6 col-lg-3 decoration-col" v-for="item in randomServices" :key="item.id">
                        <div
                            class="decoration-service-card decoration-service-card--clickable"
                            role="link"
                            tabindex="0"
                            @click="goDetail(item.id)"
                            @keydown.enter.prevent="goDetail(item.id)"
                            @keydown.space.prevent="goDetail(item.id)"
                        >
                            <div class="decoration-service-banner-wrap" v-if="item.service_thumbnail || item.service_banner">
                                <img :src="item.service_thumbnail || item.service_banner" :alt="item.service_name" class="decoration-service-banner" />
                            </div>
                            <div v-else class="not-uploaded-box decoration-service-banner-fallback">Not uploaded</div>
                            <div class="decoration-service-content">
                                <h2 class="decoration-service-title">{{ item.service_name || "Not uploaded" }}</h2>
                                <p class="decoration-service-desc">{{ item.service_description || item.description || "Not uploaded" }}</p>
                                <a href="javascript:void(0)" class="decoration-service-readmore" @click.stop.prevent="goDetail(item.id)">Read more</a>
                                <!--
                                  To bring back "Shop" button in recommendation cards:
                                  1) Uncomment this block
                                  2) Keep goHome() method enabled
                                  3) Keep .decoration-service-btn* styles enabled below
                                <div class="decoration-service-btn-wrap">
                                    <a href="javascript:void(0)" class="decoration-service-btn" @click.stop.prevent="goHome">Shop</a>
                                </div>
                                -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <div v-if="videoPopupVisible" class="video-popup-overlay" @click.self="closeVideoPopup">
            <div class="video-popup-box">
                <button type="button" class="video-popup-close" aria-label="Close" @click="closeVideoPopup">&times;</button>
                <div v-if="whyVideoSource && isEmbedUrl(whyVideoSource)" class="embed-responsive embed-responsive-16by9">
                    <iframe :src="embedUrl(whyVideoSource)" class="embed-responsive-item" allowfullscreen></iframe>
                </div>
                <video
                    v-else-if="whyVideoSource"
                    :src="whyVideoSource"
                    controls
                    playsinline
                    class="w-100"
                    style="max-height: 80vh;"
                ></video>
            </div>
        </div>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon class="rect" points="0 0 0 40 40 40 40 0"></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";

export default {
    name: "DecorationServiceDetail",
    data() {
        return {
            service: {},
            allServices: [],
            isLoader: true,
            videoPopupVisible: false,
            reviewCarouselInitTries: 0
        };
    },
    computed: {
        reviewImages() {
            const list = this.service.product_review_images || [];
            return [...list].sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
        },
        hasWhyVideo() {
            return !!(this.service.dtg_url && String(this.service.dtg_url).trim());
        },
        whyVideoSource() {
            return this.hasWhyVideo ? String(this.service.dtg_url).trim() : "";
        },
        whyDisplayImage() {
            if (this.service.dtg_banner) return this.service.dtg_banner;
            if (this.hasWhyVideo) return this.videoThumbnailFromUrl(this.whyVideoSource) || "";
            return "";
        },
        whyServiceHeading() {
            const name = (this.service.ecomm_display || "").trim();
            if (!name) return "Why Service";
            return `Why ${name} Service`;
        },
        randomServices() {
            const currentId = Number(this.$route.params.id);
            const filtered = this.allServices.filter((s) => Number(s.id) !== currentId);
            return filtered.sort(() => 0.5 - Math.random()).slice(0, 4);
        }
    },
    mounted() {
        this.loadPageData();
    },
    beforeDestroy() {
        this.destroyReviewCarousel();
        // Safety: restore scroll on navigation
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.width = "";
    },
    watch: {
        "$route.params.id"() {
            this.loadPageData();
        },
        reviewImages() {
            this.$nextTick(() => {
                this.initReviewCarousel();
            });
        },
        videoPopupVisible(visible) {
            // Lock background scroll when popup is open
            if (visible) {
                document.body.style.overflow = "hidden";
                document.body.style.position = "fixed";
                document.body.style.width = "100%";
            } else {
                document.body.style.overflow = "";
                document.body.style.position = "";
                document.body.style.width = "";
            }
        }
    },
    methods: {
        isEmbedUrl(url) {
            if (!url) return false;
            return /youtube\.com|youtu\.be|vimeo\.com/i.test(url);
        },
        embedUrl(url) {
            if (!url) return "";
            if (url.includes("youtube.com/watch")) {
                const m = url.match(/[?&]v=([^&]+)/);
                return m && m[1] ? `https://www.youtube.com/embed/${m[1]}` : url;
            }
            if (url.includes("youtu.be/")) {
                const m = url.match(/youtu\.be\/([^?]+)/);
                return m && m[1] ? `https://www.youtube.com/embed/${m[1]}` : url;
            }
            if (url.includes("vimeo.com")) {
                const m = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                return m && m[1] ? `https://player.vimeo.com/video/${m[1]}` : url;
            }
            return url;
        },
        videoThumbnailFromUrl(url) {
            if (!url || typeof url !== "string") return "";
            const u = url.trim();
            if (/youtube\.com|youtu\.be/i.test(u)) {
                let id = null;
                if (u.includes("youtube.com/watch")) {
                    const m = u.match(/[?&]v=([^&]+)/);
                    id = m ? m[1] : null;
                } else if (u.includes("youtu.be/")) {
                    const m = u.match(/youtu\.be\/([^?]+)/);
                    id = m ? m[1] : null;
                }
                return id ? `https://img.youtube.com/vi/${id}/hqdefault.jpg` : "";
            }
            if (/vimeo\.com/i.test(u)) {
                const m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
                const id = m ? m[1] : null;
                if (id) return `https://vumbnail.com/${id}.jpg`;
            }
            return "";
        },
        async loadPageData() {
            const id = this.$route.params.id;
            this.isLoader = true;
            try {
                const [detailRes, listRes] = await Promise.all([
                    ApiService.get("public/decoration-services", id),
                    ApiService.query("public/decoration-services", { params: {} })
                ]);
                this.service = (detailRes.data && detailRes.data.service) || {};
                this.allServices = (listRes.data && listRes.data.services) || [];
                this.reviewPage = 1;
                this.$nextTick(() => {
                    this.initReviewCarousel();
                });
            } catch (e) {
                this.service = {};
                this.allServices = [];
                this.destroyReviewCarousel();
            } finally {
                this.isLoader = false;
            }
        },
        destroyReviewCarousel() {
            const $ = window.$ || window.jQuery;
            if (!$ || !$.fn || !$.fn.owlCarousel) return;
            const $carousel = $(this.$refs.productReviewCarousel);
            if ($carousel && $carousel.hasClass("owl-loaded")) {
                $carousel.trigger("destroy.owl.carousel");
                $carousel.removeClass("owl-loaded");
                $carousel.find(".owl-stage-outer").children().unwrap();
            }
        },
        initReviewCarousel() {
            const $ = window.$ || window.jQuery;
            if (!this.reviewImages.length) return;
            if (!$ || !$.fn || !$.fn.owlCarousel) {
                if (this.reviewCarouselInitTries < 8) {
                    this.reviewCarouselInitTries += 1;
                    setTimeout(() => this.initReviewCarousel(), 200);
                }
                return;
            }
            const carouselEl = this.$refs.productReviewCarousel;
            if (!carouselEl) return;

            const $carousel = $(carouselEl);
            if ($carousel.hasClass("owl-loaded")) {
                $carousel.trigger("destroy.owl.carousel");
            }
            this.reviewCarouselInitTries = 0;

            $carousel.owlCarousel({
                loop: this.reviewImages.length > 4,
                margin: 16,
                nav: this.reviewImages.length > 4,
                dots: false,
                mouseDrag: true,
                touchDrag: true,
                responsive: {
                    0: { items: 1, margin: 12 },
                    576: { items: 2, margin: 12 },
                    992: { items: 3, margin: 16 },
                    1200: { items: 4, margin: 16 }
                }
            });
        },
        openVideoPopup() {
            if (this.hasWhyVideo) this.videoPopupVisible = true;
        },
        closeVideoPopup() {
            this.videoPopupVisible = false;
        },
        // Used only if Shop CTA blocks (commented in template) are restored.
        goHome() {
            this.$router.push({ name: "home" });
        },
        goDetail(id) {
            this.$router.push({ name: "DecorationServiceDetail", params: { id } });
        }
    }
};
</script>

<style scoped>
.not-uploaded-box {
    min-height: 160px;
    background: #f3f3f3;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
}
.detail-service-banner {
    width: 100%;
    max-width: 720px;
    height: 380px;
    object-fit: cover;
}
.why-media-wrap {
    position: relative;
    width: 100%;
    max-width: 720px;
}
.why-display-image {
    width: 100%;
    max-width: 720px;
    height: 380px;
    object-fit: cover;
    object-position: center;
}
.why-play-overlay {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    z-index: 2;
}
.why-play-overlay::before {
    content: "";
    width: 56px;
    height: 56px;
    border-radius: 999px;
    background: rgba(0, 0, 0, 0.55);
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.25);
    position: absolute;
}
.why-play-icon {
    width: 18px;
    height: 18px;
    position: relative;
    z-index: 3;
    filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.35));
}
.video-popup-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}
.video-popup-box {
    position: relative;
    width: 100%;
    max-width: 900px;
    background: #000;
    border-radius: 8px;
    overflow: hidden;
}
.video-popup-close {
    position: absolute;
    top: 8px;
    right: 12px;
    z-index: 10;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    border: none;
    font-size: 28px;
    line-height: 1;
    padding: 0 8px;
    cursor: pointer;
    border-radius: 4px;
}
/* Match DecorationMethods.vue: cmn-section decoration-section cards */
.decoration-section {
    padding-top: 64px;
    padding-bottom: 56px;
}
.decoration-cards-row {
    margin-left: -6px !important;
    margin-right: -6px !important;
}
.decoration-col {
    padding-left: 6px !important;
    padding-right: 6px !important;
    margin-bottom: 20px;
    display: flex;
}
.decoration-service-card {
    width: 100%;
    min-height: 428px;
    background: #ffffff;
    border: 1px solid #BEBEBE66;
    display: flex;
    flex-direction: column;
}
.decoration-service-card--clickable {
    cursor: pointer;
}
.decoration-service-banner-wrap {
    width: 100%;
    height: 222px;
    max-height: 222px;
    background: #efefef;
}
.decoration-service-banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.decoration-service-banner-fallback {
    width: 100%;
    height: 222px;
    min-height: 222px;
}
.decoration-service-content {
    background: #ffffff;
    padding: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;
    box-shadow: 0px 4px 12px 0px #0000001F;
}
.decoration-service-title {
    font-size: 18px;
    line-height: 18px;
    font-weight: 700;
    color: #000000;
    margin: 0 0 12px 0;
}
.decoration-service-desc {
    margin: 0 0 12px 0;
    font-size: 14px;
    line-height: 18px;
    color: #606060;
    min-height: 55px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.decoration-service-readmore {
    display: inline-block;
    margin-top: auto;
    margin-bottom: 0;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    color: #1D6CB5;
}
/*
  Restore these styles if Shop CTA is re-enabled in recommendation cards.
.decoration-service-btn-wrap {
    margin-top: auto;
}
.decoration-service-btn {
    display: block;
    text-align: center;
    border: 1px solid #1D6CB5;
    color: #1D6CB5;
    padding: 12px 8px;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    background: #ffffff;
    margin-top: 12px;
    position: relative;
    overflow: hidden;
    transition: color 220ms ease, border-color 220ms ease;
    z-index: 0;
}
.decoration-service-btn::before {
    content: "";
    position: absolute;
    inset: 0;
    background: #1D6CB5;
    transform: translateX(-100%);
    transition: transform 320ms ease;
    z-index: -1;
}
.decoration-service-btn:hover {
    color: #ffffff;
    border-color: #1D6CB5;
}
.decoration-service-btn:hover::before {
    transform: translateX(0);
}
*/
.decoration-pagination {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    gap: 10px;
    margin-top: 2rem;
    margin-bottom: 1rem;
}
.decoration-pagination button {
    font-family: inherit;
    font-size: 0.9375rem;
    line-height: 1.4;
    cursor: pointer;
    border-radius: 4px;
}
.decoration-pagination__prev {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0.45rem 0.85rem;
    color: #333;
    background: #fff;
    border: 1px solid #d0d0d0;
}
.decoration-pagination__num {
    min-width: 2.25rem;
    height: 2.25rem;
    padding: 0 0.35rem;
    color: #333;
    background: #fff;
    border: 1px solid #d0d0d0;
}
.decoration-pagination__num--active {
    color: #fff;
    background: #f2790c;
    border-color: #f2790c;
}
.decoration-pagination__next {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 0.45rem 0.85rem;
    color: #fff;
    background: #f2790c;
    border: 1px solid #f2790c;
}
.decoration-pagination__arrow {
    font-size: 0.875em;
}

@media (max-width: 991px) {
    .decoration-service-card {
        min-height: 355px;
    }
    .decoration-service-banner-wrap {
        height: 222px;
        max-height: 222px;
    }
    .decoration-service-banner-fallback {
        height: 222px;
        min-height: 222px;
    }
    .decoration-service-desc,
    .decoration-service-readmore {
        font-size: 18px;
    }
}
@media (max-width: 767px) {
    .decoration-col {
        margin-bottom: 16px;
    }
    .decoration-service-desc,
    .decoration-service-readmore {
        font-size: 16px;
    }
    .decoration-service-btn {
        font-size: 16px;
    }
}
/* Product Preview slider */
.decoration-section .decoration-section-heading{
    margin-bottom: 30px;
}
.product-review-slider {
    position: relative;
    margin-top: 0;
}
.product-review-slide__box{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 360px;
    /* background: #DBDBDB; */
    overflow: hidden;
}
.product-review-slide__box .product-review-image{
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
    text-align: center;
}
.product-review-name {
    margin: 16px 0 0;
    font-size: 24px;
    line-height: 24px;
    color: #000000;
    text-align: center;
    font-weight: 400;
    margin-top: 16px;
}
.product-review-slider--owl :deep(.owl-stage-outer) {
    padding-bottom: 4px;
}
.product-review-slider--owl :deep(.owl-item .product-review-slide) {
    width: 100%;
}
.product-review-slider--owl :deep(.owl-nav) {
    margin-top: 0;
}
.product-review-slider--owl :deep(.owl-nav button.owl-prev),
.product-review-slider--owl :deep(.owl-nav button.owl-next) {
    position: absolute;
    top: 180px;
    transform: translateY(-50%);
    width: 37px;
    height: 39px;
    padding: 0 !important;
    margin: 0 !important;
    border: none !important;
    background-color: #F2790C !important;
    background-image: url("/maincss/images/slder_left_arrow.svg") !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
    border-radius: 0;
}
.product-review-slider--owl :deep(.owl-nav button.owl-prev) {
    left: -11px;
}
.product-review-slider--owl :deep(.owl-nav button.owl-next) {
    right: -11px;
    transform: translateY(-50%) rotateZ(180deg);
}
.product-review-slider--owl :deep(.owl-nav button.owl-prev span),
.product-review-slider--owl :deep(.owl-nav button.owl-next span) {
    display: none;
}
.product-review-slider--owl :deep(.owl-nav button.owl-prev:hover),
.product-review-slider--owl :deep(.owl-nav button.owl-next:hover) {
    box-shadow: -2px -2px 12px 0 rgba(0, 0, 0, 0.13) !important;
}
.product-review-slider--owl :deep(.owl-nav button.disabled) {
    opacity: 0.45;
    cursor: not-allowed;
}
.decoration-section-description {
    color: #414141;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    margin-bottom: 0px;
}
/* Why section: scroll long HTML; side-by-side height matches .why-display-image via .why-section-text-col */
.why-section-description {
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    word-break: break-word;
    padding-right: 8px;
}
/* ≥769px: text column same height as media; heading + scrollable description fill that box */
@media (min-width: 769px) {
    .why-section-row > .why-section-text-col {
        display: flex;
        flex-direction: column;
        height: 380px;
        min-height: 0;
    }
    .why-section-text-col .decoration-section-heading {
        flex-shrink: 0;
    }
    .why-section-text-col .why-section-description {
        flex: 1 1 auto;
        min-height: 0;
        max-height: none;
    }
}
@media (min-width: 769px) and (max-width: 991px) {
    .why-section-row > .why-section-text-col {
        height: 320px;
    }
}
.why-section-description :deep(p) {
    margin: 0 0 0.5em;
}
.why-section-description :deep(p:last-child) {
    margin-bottom: 0;
}
.decoration-section-description p{
    margin-bottom: 0px;

}
@media (max-width: 991px) {
    .product-review-slide__box {
        width: 100%;
        height: 320px;
    }
    .product-review-slider--owl :deep(.owl-nav button.owl-prev),
    .product-review-slider--owl :deep(.owl-nav button.owl-next) {
        top: 160px;
    }
}
@media (max-width: 576px) {
    .product-review-slider--owl {
        padding: 0 36px;
    }
}

.decoration-shop-now-btn {
    background-color: #F2790C;
    border: 1px solid #f2790c;
    color: #ffffff;
    font-size: 16px;
    line-height: 16px;
    font-weight: 600;
    padding: 12px 8px;
    border-radius: 2px;
    margin-top: 24px;
}
.decoration-shop-now-btn:hover,
.decoration-shop-now-btn:focus,
.decoration-shop-now-btn:active {
    background-color: #f2790c !important;
    border-color: #f2790c !important;
    color: #ffffff !important;
    box-shadow: none !important;
    transform: none !important;
}
.decoration-intro-content {
    background: #edf3fb;
    padding-top: 24px;
    padding-bottom: 24px;
}
.decoration-section-heading {
    font-weight: 500;
    font-size: 40px;
    line-height: 40px;
    color: #000000;
    margin-bottom: 16px;
}

/* Breadcrumb (match screenshot) */
.decoration-breadcrumb {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    font-size: 14px;
    line-height: 20px;
    color: #1D6CB5;
    font-weight: 400;
}
.decoration-breadcrumb__link {
    color: #1D6CB5;
    text-decoration: none;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    margin-bottom: 0px;
}
.decoration-breadcrumb__link:hover {
    color: #1D6CB5;
    text-decoration: underline;
}
.decoration-breadcrumb__sep {
    color: #8b8b8b;
}
.decoration-breadcrumb__current {
    color: #666666;
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
}
.decoration-detail-hero__breadcrumb {
    margin-bottom: 14px;
}

/* Hero (match screenshot) */
.decoration-detail-hero__content{
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
    margin-top: 40px;
}
.decoration-detail-hero-section.cmn-section {
    padding-top: 0;
    padding-bottom: 0px;
}
.print-service-section.cmn-section{
    padding-top: 64px;
    padding-bottom: 0px;
}
.why-section-row {
    column-gap: 48px;
    margin-left: 0;
    margin-right: 0;
    align-items: flex-start;
}
.why-section-row > .col-md-6 {
    padding-left: 0;
    padding-right: 0;
    flex: 0 0 calc(50% - 24px);
    max-width: calc(50% - 24px);
}
.slider-section.cmn-section{
    padding-top: 64px;
    padding-bottom: 0px;
}
.slider-section.cmn-section .decoration-section-heading{
    margin-bottom: 40px;
}
.decoration-detail-hero {
    display: grid;
    grid-template-columns: 1fr 1fr;
    align-items: stretch;
    height: 380px;
    gap: 0px;
}
.decoration-detail-hero__left {
    position: relative;
    background: #eef3f7;
    display: flex;
    align-items: flex-start;
    padding: 40px 40px 40px 125px;
    max-width: 40%;
    width: 100%;
    flex-direction: column;
    min-height: 380px;
}
.decoration-detail-service-name {
    font-size: 48px;
    font-weight: 700;
    line-height: 50px;
    color: #000000;
    letter-spacing: -0.02em;
    margin-bottom: 16px;
}
.decoration-detail-hero__desc {
    color: #606060;
    font-size: 16px;
    line-height: 20px;
    min-height: 55px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.decoration-detail-hero__cta {
    width: max-content;
    min-width: 121px;
    padding: 14px;
    font-size: 12px;
    line-height: 12px;
    border-radius: 2px;
    height: 40px;
}
.decoration-detail-hero {
    width: 100%;
    max-height: 380px;
    min-height: 380px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.decoration-detail-hero__right {
    background: transparent;
    overflow: hidden;
    max-width: 60%;
    width: 100%;
}
.decoration-detail-hero__right .detail-service-banner_img{
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
    min-height: 380px;
    max-height: 380px;
}
.decoration-detail-hero__media,
.decoration-detail-hero__fallback {
    width: 100%;
    height: 100%;
}
.detail-service-banner {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
}

@media (max-width: 768px) {
    .decoration-detail-hero {
        grid-template-columns: 1fr;
        height: auto;
    }
    .decoration-detail-hero__right {
        min-height: 200px;
    }
    .decoration-detail-hero__left {
        max-width: 100%;
    }
    .decoration-detail-hero__right {
        max-width: 100%;
    }
    .decoration-detail-hero{
        flex-direction: column;
    }
}

/* =========================
   Responsive (all sections)
   ========================= */

/* Ensure hero uses flex layout consistently (there are legacy grid rules above) */
.decoration-detail-hero {
    display: flex;
    align-items: stretch;
}
.decoration-detail-hero__left {
    flex: 0 0 40%;
}
.decoration-detail-hero__right {
    flex: 1 1 60%;
}
.decoration_slider .insta_feed_content{
    display: none !important;
}
@media (max-width: 1200px) {
    .decoration-detail-hero__left {
        padding: 32px 28px 32px 48px;
    }
    .decoration-detail-service-name {
        font-size: 40px;
        line-height: 44px;
    }
    .decoration-detail-hero__content {
        margin-top: 24px;
    }
}

@media (max-width: 991px) {
    .decoration-detail-hero {
        height: auto;
        max-height: none;
        min-height: 0;
    }
    .decoration-detail-hero__left {
        padding: 24px;
        max-width: 45%;
        flex-basis: 45%;
        min-height: 320px;
    }
    .decoration-detail-hero__right {
        min-height: 320px;
    }
    .decoration-detail-service-name {
        font-size: 32px;
        line-height: 36px;
    }
    .decoration-detail-hero__desc {
        font-size: 14px;
        line-height: 18px;
        min-height: 0;
        -webkit-line-clamp: 4;
        line-clamp: 4;
    }
    .decoration-detail-hero__right .detail-service-banner_img {
        height: 320px;
        min-height: 320px;
        max-height: 320px;
    }

    /* Why section media */
    .why-media-wrap,
    .why-display-image {
        max-width: 100%;
        height: 320px;
    }

    /* Product Preview slider */
    .product-review-slide__box {
        width: 100%;
        height: 320px;
    }
    .product-review-slide__box .product-review-image {
        width: 220px;
        height: 220px;
    }
    .product-review-slider--owl :deep(.owl-nav button.owl-prev),
    .product-review-slider--owl :deep(.owl-nav button.owl-next) {
        top: 160px;
    }
    .product-review-name {
        font-size: 16px;
        line-height: 18px;
    }
}

@media (max-width: 768px) {
    /* Hero stack */
    .decoration-detail-hero {
        flex-direction: column;
        height: auto;
    }
    .decoration-detail-hero__left {
        max-width: 100%;
        flex: 0 0 auto;
        padding: 18px 16px;
        min-height: auto;
    }
    .decoration-detail-hero__right {
        max-width: 100%;
        width: 100%;
        flex: 0 0 auto;
        min-height: 220px;
    }
    .decoration-detail-hero__right .detail-service-banner_img {
        min-height: 220px;
        max-height: none;
        height: 220px;
    }
    .decoration-detail-hero__media,
    .decoration-detail-hero__fallback {
        height: 220px;
    }
    .decoration-detail-service-name {
        font-size: 28px;
        line-height: 32px;
    }

    /* Why section */
    .print-service-section.cmn-section {
        padding-top: 40px;
    }
    .why-section-row {
        column-gap: 0;
    }
    .why-section-row > .col-md-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }
    .why-media-wrap,
    .why-display-image {
        height: 400px;
    }
    .why-section-text-col {
        display: block;
        height: auto;
        min-height: 0;
    }
    .why-section-text-col .why-section-description {
        flex: none;
        max-height: 400px;
    }

    /* Product Preview */
    .slider-section.cmn-section {
        padding-top: 40px;
    }
    .product-review-slider--owl :deep(.owl-nav button.owl-prev) {
        left: -11px;
    }
    .product-review-slider--owl :deep(.owl-nav button.owl-next) {
        right: -11px;
    }
}
@media (max-width: 1441px) {
.decoration-hero__left{
    padding-left: 30px;
}
.detail-service-banner {
    max-width: 604px;
}
.why-display-image {
    max-width: 604px;
}
}
@media (max-width: 767px) {
    .decoration-section-heading {
        font-size: 28px;
        line-height: 32px;
    }
    .decoration-section-description p,
    .decoration-section-description ul li,
    .why-section-description {
        font-size: 14px;
        line-height: 18px;
    }

    .product-review-name {
        font-size: 14px;
        line-height: 18px;
    }
    .product-review-slider--owl :deep(.owl-item .product-review-name) {
        font-size: 14px;
        line-height: 18px;
    }
    .print-service-section .decoration-section-heading{
        margin-top: 16px;
    }
}
</style>
